// Terms query
import { graphql } from "../gql";

export const query = graphql(`
    query AcceptTermsQuery {
        terms {
            terms
            settingsTerms
        }
    }
`);

// Accept terms mutation

export const acceptMutation = graphql(`
    mutation AcceptTermsMutation {
        currentUserAcceptTerms {
            error
            redirectUrl
        }
    }
`);
